export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_BUILD_ID = process.env.REACT_APP_BUILD_ID;
